import { IExhibitorPair, IStand } from "@evennt-tech/api-v2-core";
import { groupBy } from "lodash";
import { StandsWithCompanies } from "ts/api/chat";

const groupPairsByStand = (pairs: IExhibitorPair[]): StandsWithCompanies[] =>
  Object.values(groupBy(pairs, ({ stand }) => stand?.standId as string)).map(
    (standPairs) => ({
      pairs: standPairs,
      allCompaniesNames: standPairs
        .map(({ companyToShow }) => companyToShow?.company?.name)
        .filter(Boolean)
        .join(", "),
      stand: standPairs[0].stand as IStand,
    })
  );

export const findStandLogo = (pairs: IExhibitorPair[]): string =>
  pairs.find((pair) => pair?.companyToShow?.company?.companyInfo?.logoFile?.url)
    ?.companyToShow?.company?.companyInfo?.logoFile?.url ?? "";

export default groupPairsByStand;
